import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Hash from "./views/Hash";
import Moratorias from "./views/Moratorias";
import portalcliente from "./views/PortalCliente";
import Components from "./views/Components.vue";
import Landing from "./views/Landing.vue";
import Inicio from "./views/Inicio.vue";
import Nosotros from "./views/Nosotros.vue";
import DondeEstamos from "./views/donde-estamos.vue";
import Productos from "./views/Productos.vue";
import notin from "./views/notin.vue";
import kubo from "./views/kubo.vue";
import nexus from "./views/nexus.vue";
import notariavirtual from "./views/notariavirtual.vue";
import paginaweb from "./views/PaginaWeb.vue";
// import Starter from "./views/Starter.vue";
// import Login from "./views/Login.vue";
// import Register from "./views/Register.vue";
// import Profile from "./views/Profile.vue";

Vue.use(Router);

//redireccion busqueda blog
if(location.href.indexOf("/?s=") > 0){
  location.href = location.origin + '/portal/' + location.search
}

export default new Router({
  linkExactActiveClass: "active",
  mode: "hash",
  base: process.env.environment === "development" ? "/" : "/",
  routes: [
    {
      path: "/",
      name: "inicio",
      components: {
        header: AppHeader,
        default: Inicio,
        footer: AppFooter
      }
    },
    {
      path: "/hash",
      name: "Hash",
      components: {
        header: AppHeader,
        default: Hash,
        footer: AppFooter
      }
    },
    {
      path: "/moratorias",
      name: "moratorias",
      components: {
        header: AppHeader,
        default: Moratorias,
        footer: AppFooter
      }
    },
    {
      path: "/portalcliente",
      name: "portalcliente",
      components: {
        header: AppHeader,
        default: portalcliente,
        footer: AppFooter
      }
    },
    {
      path: "/components",
      name: "components",
      components: {
        header: AppHeader,
        default: Components,
        footer: AppFooter
      }
    },
    {
      path: "/landing",
      name: "landing",
      components: {
        header: AppHeader,
        default: Landing,
        footer: AppFooter
      }
    },
    {
      path: "/nosotros",
      name: "nosotros",
      components: {
        header: AppHeader,
        default: Nosotros,
        footer: AppFooter
      }
    },
    {
      path: "/donde-estamos",
      name: "donde-estamos",
      components: {
        header: AppHeader,
        default: DondeEstamos,
        footer: AppFooter
      }
    },
    {
      path: "/productos",
      name: "productos",
      components: {
        header: AppHeader,
        default: Productos,
        footer: AppFooter
      }
    },
    {
      path: "/notin",
      name: "notin",
      components: {
        header: AppHeader,
        default: notin,
        footer: AppFooter
      }
    },
    {
      path: "/kubo",
      name: "kubo",
      components: {
        header: AppHeader,
        default: kubo,
        footer: AppFooter
      }
    },
    {
      path: "/nexus",
      name: "nexus",
      components: {
        header: AppHeader,
        default: nexus,
        footer: AppFooter
      }
    },
    {
      path: "/notariavirtual",
      name: "notariavirtual",
      components: {
        header: AppHeader,
        default: notariavirtual,
        footer: AppFooter
      }
    },
    {
      path: "/avisolegal",
      name: "avisolegal",
      components: {
        header: AppHeader,
        default: ()=>import('@/views/AvisoLegal.vue'),
        footer: AppFooter
      }
    },
    {
      path: "/cookies",
      name: "cookies",
      components: {
        header: AppHeader,
        default: ()=>import('@/views/Cookies.vue'),
        footer: AppFooter
      }
    },
    {
      path: "/politicaprivacidad",
      name: "politicaprivacidad",
      components: {
        header: AppHeader,
        default: ()=>import('@/views/PoliticaPrivacidad.vue'),
        footer: AppFooter
      }
    },
    {
      path: "/protecciondatos",
      name: "protecciondatos",
      components: {
        header: AppHeader,
        default: ()=>import('@/views/ProteccionDatos.vue'),
        footer: AppFooter
      }
    },
    {
      path: "/pagina-web",
      name: "paginaweb",
      components: {
        header: AppHeader,
        default: paginaweb,
        footer: AppFooter
      }
    },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // }
    // dynamic redirect, note that the target route `to` is available for the redirect function
    
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
